import {
  ActionType,
  IDeleteClassData,
} from "../../../models/classmanagement/deleteClass";
import { IResponse } from "models";

export const deleteClassAction = (payload: IDeleteClassData) => {
  return {
    type: ActionType.DELETE_CLASS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DELETE_CLASS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.DELETE_CLASS_SUCCESS,
    payload,
  };
};
